import { mergeClassName } from '../../../utils/mergeClassName'

type LogoProps = {
  url: string
  small?: boolean
}

const Logo: React.FC<LogoProps> = ({ url, small = false }) => {
  return (
    <div className={mergeClassName(
      'w-[100px] flex shrink-0 items-center justify-center transition-all',
      small && 'lg:w-[80px]',
    )}
    >
      <img
        src={url}
        alt=""
        className={mergeClassName(
          'max-h-[75px] transition-all',
          small && 'sm:max-h-[50px]',
        )}
      />
    </div>
  )
}

export default Logo
